import React from "react";
import firebase from "../../firebase";
import {
  Dropdown,Confirm
} from "semantic-ui-react";

import { withRouter } from "react-router-dom";
import { ROUTES_NAMES } from "../../routes";
import { isAdmin} from "../../adminUsers";

class ReportDropdown extends React.Component {

  state = {
    channelsRef: firebase.database().ref("channels"),
    articlesRef: firebase.database().ref("articles"),
    objectType : this.props.channel ? "channel" : "article",
    openConfirmBox : false,
    action:"",
    admin: this.props.admin && this.props.admin===true ? true : false
  };
  
  setDropDown()
  {
    if(this.state.objectType === "channel")
        {return (<Dropdown text= {this.state.admin ? 'Unreport' : 'Report'}>
            <Dropdown.Menu>
              {this.state.admin ? null : <Dropdown.Item key= "edit" icon= "flag" text= "Report" value= "report" onClick = {() => this.handleDropDownClick("report")}/>}
              {this.state.admin || (this.props.user.uid === this.props.channel.createdBy.userId)? <Dropdown.Item key= "delete" icon= "delete" text= "Remove" value= "delete" onClick = {() => this.handleDropDownClick("delete")}/> : null}
              {this.state.admin ? <Dropdown.Item key= "edit" icon= "undo" text= "Unreport" value= "unreport" onClick = {() => this.handleDropDownClick("unreport")}/> : null}
            </Dropdown.Menu>
          </Dropdown>)}
    else{return (<Dropdown text= {this.state.admin ? 'Unreport' : 'Report'}>
            <Dropdown.Menu>
              {this.state.admin ? null :<Dropdown.Item key= "edit" icon= "flag" text= "Report" value= "report" onClick = {() => this.handleDropDownClick("report")}/>}
              {isAdmin(this.props.user.email)? <Dropdown.Item key= "delete" icon= "delete" text= "Remove" value= "delete" onClick = {() => this.handleDropDownClick("delete")}/> : null}
              {this.state.admin ? <Dropdown.Item key= "edit" icon= "undo" text= "Unreport" value= "unreport" onClick = {() => this.handleDropDownClick("unreport")}/> : null}
            </Dropdown.Menu>
          </Dropdown>)
    }
      
  }

  getRef()
  {
    return this.state.objectType === "channel" ? this.state.channelsRef : this.state.articlesRef;
  }
  getId()
  {
    return this.state.objectType === "channel" ? this.props.channel.id : this.props.article.id;
  }

  handleDropDownClick(act){
    this.setState({openConfirmBox : true,action:act});
  }

  closeConfirmBox() {
    this.setState({openConfirmBox : false,action:""});
  }
  confirmAction(){
    let act = this.state.action;
    if(act === "report") this.reportFunction();
    else if(act === "delete") this.deleteFunction();
    else if(act === "unreport") this.unreportFunction();
    this.closeConfirmBox();
  }

  deleteFunction(){
    this.getRef()
    .child(this.getId())
      .remove()
      .then(() => {
        console.log("Object removed");
      })
      .catch((err) => console.error(err));

      if(this.state.objectType === "channel" && (!this.state.admin))this.props.history.push(ROUTES_NAMES.cloudsFeed)
  }

  reportFunction(){
    
    this.getRef()
    .child(this.getId())
      .update({ reported: true })
      .then(() => {
        console.log("Object reported");
      })
      .catch((err) => console.error(err));
  }

  unreportFunction(){
    
    this.getRef()
    .child(this.getId())
      .update({ reported: false })
      .then(() => {
        console.log("Object unreported");
      })
      .catch((err) => console.error(err));
  }
  

  render(){

    return(
      <React.Fragment>
        {this.setDropDown()}
        <Confirm
          open={this.state.openConfirmBox}
          onCancel={() => this.closeConfirmBox()}
          onConfirm={() => this.confirmAction()}
        />
      </React.Fragment>
    );
  }
}

export default withRouter(ReportDropdown);



// WEBPACK FOOTER //
// ./src/components/SidePanel/ReportDropdown.js